import React from "react";
import { useTranslation } from "react-i18next";
import {Inbox} from "lucide-react"; // optional icon (npm i lucide-react)


export default function EmptyData  (){
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 bg-light rounded-2xl shadow-custom-light">
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary/10 mb-6">
        <Inbox className="w-8 h-8 text-primary" />
      </div>

      <h2 className="text-2xl font-semibold text-Black mb-2">
        {t("empty.title")}
      </h2>

      <p className="text-muted mb-6 max-w-md">
        {t("empty.description")}
      </p>
    </div>
  );
};

